import ReactECharts from 'echarts-for-react';
import React from 'react';

const ScatterPlotChart = ({ item }) => {
  const option = {
    title: {
      text: item.title.text,
    },
    xAxis: {
      name: item.xAxis.name || '',
      type: item.xAxis.type,
    },
    yAxis: {
      name: item.yAxis.name || '',
      type: item.yAxis.type,
    },
    series: item.series.map((seriesItem) => ({
      type: seriesItem.type,
      symbolSize: seriesItem.symbolSize,
      data: seriesItem.data,
    })),
    dataZoom: [
      {
        type: 'slider', // Slider zoom control for x-axis
        xAxisIndex: 0,
        start: 0, // Initial start position for x-axis
        end: 100, // Initial end position for x-axis
      },
      {
        type: 'slider', // Slider zoom control for y-axis
        yAxisIndex: 0,
        start: 0, // Initial start position for y-axis
        end: 100, // Initial end position for y-axis
      },
      {
        type: 'inside', // Allows zooming and panning using mouse scroll and drag for x-axis
        xAxisIndex: 0,
      },
      {
        type: 'inside', // Allows zooming and panning using mouse scroll and drag for y-axis
        yAxisIndex: 0,
      },
    ],
    tooltip: {
      trigger: 'item',
      formatter: (params) => `X: ${params.value[0]}<br/>Y: ${params.value[1]}`,
    },
  };

  return <ReactECharts option={option} style={{ height: '400px', width: '100%' }} />;
};

export default ScatterPlotChart;
